import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core';
import { FullScreenDialog } from '../../../../ui-kit';
import { CurrentInventoryCountComponent } from '../../../../generated/graphql';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import { routePaths } from '../../../../routePaths';
import CurrentInventoryCountForm from './CurrentInventoryCountForm';

const CurrentInventoryCount = () => {
    const history = useHistory();
    const theme = useTheme();
    const { currentWarehouseId } = useWarehousesScope();
    const [isDialogOpen, setIsDialogOpened] = useState(true);

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.inventoryCounts), theme.transitions.duration.leavingScreen);
    };


    return(
        <FullScreenDialog isOpened={isDialogOpen}>
            <CurrentInventoryCountComponent
                nextFetchPolicy="cache-first"
                variables={{ warehouseId: currentWarehouseId as string }}
                redirectOnErrorUrl={routePaths.inventoryCounts}
            >
                {({ data: { currentInventoryCount, stockCardCategories } }) => {
                   return (
                       <CurrentInventoryCountForm
                           currentWarehouseId={currentWarehouseId as string}
                           stockCardCategories={stockCardCategories}
                           onClose={onClose}
                           currentInventoryCount={currentInventoryCount}
                       />
                    );
                }}
            </CurrentInventoryCountComponent>
        </FullScreenDialog>
    );
};

export default CurrentInventoryCount ;